import {exportFile} from "@/api/common";
import request from "@/utils/request";

// 仓库组级联树
export function getWarehouseGroupTree(params) {
    return request.get(`/supply/warehouse/getWarehouseGroupTree`, {params})
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

// fba库存
export function getFbaInventory(params) {
    return request.post('/supply/storage/fbaPage', params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

// 产品库存
export function getProductInventoryPage(params) {
  return request.post('/supply/productInventory/productPage', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function importProductInventoryInitCost(attId) {
  return request.post(`/supply/productInventory/import?attachmentId=${attId}`);
}

export function exportFbaInventory(params) {
    exportFile('/supply/storage/exportFbaInventory', params);
}

// 仓库库存
export function getWarehouseInventory(params) {
    return request.post('/supply/warehouseInventory/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function exportWarehouseInventory(params) {
    exportFile('/supply/warehouseInventory/exportWarehouseInventory', params);
}

// 仓库资料
export function getWarehouseInfoPage(params) {
    return request.post('/supply/warehouse/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function addWarehouseInfo(params) {
  return request.post('/supply/warehouse/save', params);
}

export function updateWarehouseInfo(params) {
  return request.put('/supply/warehouse/update', params);
}

export function updateWarehouseStatus(params) {
  return request.put('/supply/warehouse/modifyStatus', null, {params});
}

export function getWarehouseInfo(id) {
  return request.get(`/supply/warehouse/${id}`)
    .then(res => Promise.resolve(res.data))
}

// 仓库库存
export function deleteWarehouse(params) {
  return request.delete('/supply/warehouse/delete', {params});
}

export function getDeliveryOrderPage(params) {
  // return request.post('/supply/brand/page', params)
  //   .then((res) => {
  //     return Promise.resolve(res.data);
  //   });
  return new Promise(resolve => {
    setTimeout(() => resolve([
      {
        status: 'WAIT_INBOUND',
        items: [{}, {}]
      }
    ]), 500)
  })
}

// 调拨单

export function getTransferOrderPage(params) {
  return request.post('/supply/transfer/page', params)
    .then(res => res.data);
}

export function getTransferOrder(id) {
  return request.get(`/supply/transfer/queryDetail/${id}`)
    .then(res => res.data);
}

export function getCanTransferProductPage(params) {
  return request.post('/supply/transfer/canTransferProductPage', params)
    .then(res => res.data);
}

export function importTransferProduct(params) {
  return request.post('/supply/transfer/importTransferProduct', params);
}

export function getTransferMarket(params) {
  return request.get(`/supply/transfer/marketCombobox`, {params})
    .then(res => res.data);
}

export function addTransferOrder(params) {
  return request.post('/supply/transfer', params);
}

export function updateTransferOrder(params) {
  return request.put('/supply/transfer', params);
}

export function auditTransferOrder(params) {
  return request.post('/supply/transfer/arraignment', params);
}

export function passTransferOrder(params) {
  return request.post('/supply/transfer/pass', params);
}

export function productLabelsInfo(params){
  return request.post('/supply/transfer/transferListingLabelsInfo',params)
  .then((res)=>{
    return Promise.resolve(res.data)
  })
}
export function printProductLabels(params) {
  return request.post(`/supply/transfer/printTransferListingLabels`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function failTransferOrder(params) {
  return request.post('/supply/transfer/reject', params);
}

export function abolishTransferOrder(id, reason) {
  return request.post(`/supply/transfer/abolish/${id}?abolishReason=${reason}`);
}

export function deleteTransferOrder(params) {
  return request.delete(`/supply/transfer`, {params});
}

export function maintainTransferShipment(params) {
  return request.post(`/supply/transfer/maintainShipment`, params);
}

// 完成拣货
export function pickTransferOrder(params) {
  return request.post(`/supply/transfer/pick`, params);
}

// 出库
export function outboundTransferOrder(id) {
  return request.post(`/supply/transfer/outbound/${id}`);
}

export function getTransferFbaShipment(params) {
  return request.post(`/supply/transfer/queryCreateShipment`, params)
    .then(res => res.data);
}

// 装配单

export function getAssemblyOrderPage(params) {
  return request.post('/supply/assemble/page', params)
    .then(res => res.data);
}

export function cancelAssemblyOrder(params) {
  return request.post('/supply/assemble/abolish', params);
}

export function confirmAssemblyOrder(id) {
  return request.post(`/supply/assemble/confirm/${id}`);
}

export function addAssemblyOrder(params) {
  return request.post('/supply/assemble/saveAssemble', params);
}

export function updateAssemblyOrder(params) {
  return request.put('/supply/assemble', params);
}

export function updateAssemblyOrderMemo(params) {
  return request.post('/supply/assemble/updateMemo', null, {params});
}

export function getAssemblyOrderById(id) {
  return request.get(`/supply/assemble/queryDetail/${id}`)
    .then(res => res.data);
}

// 采购入库单

export function getInboundOrderPage(params) {
  return request.post('/supply/purchaseInbound/page', params)
    .then(res => res.data);
}

export function registerInbound(params) {
  return request.post('/supply/purchaseInbound/registerInbound', params);
}
// 盘点单
export function getInventoryPage(params) {
  return request.post('/supply/storageCheck/page', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function warehouseCheck(params) {
  return request.post('/supply/storageCheck/warehouseCheck', params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function getCanCheckProductPage(params) {
  return request.post('/supply/storageCheck/canCheckProductPage', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getStorageCheckDetail(id) {
  return request.get(`/supply/storageCheck/queryDetail/${id}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getStorageCheckDetailPage(params) {
  return request.post('/supply/storageCheck/itemPage', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function abolishStorageCheck(id, reason) {
  return request.post(`/supply/storageCheck/abolish/${id}?abolishReason=${reason}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function saveStorageCheck(params) {
  return request.post(`/supply/storageCheck/save`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function updateStorageCheckMemo(id, memo) {
  return request.post(`/supply/storageCheck/updateMemo?id=${id}&memo=${memo}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function startCounting(id) {
  return request.post(`/supply/storageCheck/startCheck/${id}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function updateStorageCheckItem(params) {
  return request.post(`/supply/storageCheck/updateItem`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function importStorageCheckResult(params) {
  return request.post(`/supply/storageCheck/importCheckResult`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

// 出入库记录
export function getInboundPage(params) {
  return request.post(`/supply/inbound/page`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getInboundDetail(id) {
  return request.get(`/supply/inbound/queryDetail/${id}`)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getCanOtherInboundProductPage(params) {
  return request.post(`/supply/inbound/canOtherInboundProductPage`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function getCanOtherOutboundProductPage(params) {
  return request.post(`/supply/inbound/canOtherOutboundProductPage`, params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

export function importOtherInboundProduct(params) {
  return request.post(`/supply/inbound/importOtherInboundProduct`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function importOtherOutboundProduct(params) {
  return request.post(`/supply/inbound/importOtherOutboundProduct`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function saveOtherInbound(params) {
  return request.post(`/supply/inbound/otherInbound`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function saveOtherOutbound(params) {
  return request.post(`/supply/inbound/otherOutbound`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

// 成本补录

export function getCostSupplementPage(params) {
  return request.post(`/supply/costSupplement/page`, params)
    .then(res => res.data);
}

export function auditPassCostSupplement(params) {
  return request.put(`/supply/costSupplement/review/yes`, params);
}

export function auditFailCostSupplement(params) {
  return request.post(`/supply/costSupplement/review/no`, params);
}

export function deleteCostSupplement(params) {
  return request.delete(`/supply/costSupplement`, {params});
}

export function getCostSupplementById(id) {
  return request.get(`/supply/costSupplement/get/${id}`)
    .then(res => res.data);
}

export function getCostSupplementInboundPage(params) {
  return request.post(`/supply/costSupplement/page/inbound`, params)
    .then(res => res.data);
}

export function getCostSupplementAddProductPage(params) {
  return request.post(`/supply/costSupplement/page/addProduct`, params)
    .then(res => res.data);
}

export function getInboundProduct(params) {
  return request.post(`/supply/costSupplement/page/addProduct`, params)
    .then(res => res.data.records[0]);
}

export function addCostSupplement(params) {
  return request.post(`/supply/costSupplement/save`, params);
}

export function updateCostSupplement(params) {
  return request.post(`/supply/costSupplement/update`, params);
}

